/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect, useContext } from "react";
import { onSnapshot } from "firebase/firestore";
import { useFirestore } from "../../firebase/FirestoreContext";
import "../../styles/global.css";
import { collectionPath, EnvContext } from "../../context/EnvContext";
import FeaturedCarousel_MobileV2 from "../../elements/FeaturedCarousel_MobileV2";
import FeaturedCarousel_DesktopV2 from "../../elements/FeaturedCarousel_DesktopV2";
import useWindowSize from "../../utils/useWindowSize";
import Hero from "../../elements/Hero";
import FindYourVibe from "../../elements/FindYourVibe";
import CategoryBrowse from "../../elements/CategoryBrowse";
import PageLineBreak from "../../elements/PageLineBreak";
import Testimonial from "../../elements/Testimonial";
import Knowledge from "../../elements/Knowledge";
import FAQ from "../../elements/FAQ";
import HorizontalListing_Homepage from "../../elements/HorizontalListing_Homepage";
import PageLayout from "../../elements/PageLayout";
import Header from "../../elements/Header";
import getListingsCollection from "../../utils/getListingsCollection";


const Homepage = () => {
  const environment = useContext(EnvContext);
  const { width } = useWindowSize();
  const isMobile = width <= 768;

  const db = useFirestore();

  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      getListingsCollection(db),
      (snapshot) => {
        const listings = snapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((listing) => listing.listing_price > 0);

        let filteredListings = listings;

        // Sort filtered listings
        filteredListings.sort((a, b) => {
          if (a.listing_stock_amount === 0 && b.listing_stock_amount !== 0) {
            return 1;
          }
          if (a.listing_stock_amount !== 0 && b.listing_stock_amount === 0) {
            return -1;
          }
          return 0;
        });

        // Sort sooperdeals
        filteredListings.sort((a, b) => {
          const isSooperDealA = a.sooperdeal_start_date && a.sooperdeal_price !== undefined;
          const isSooperDealB = b.sooperdeal_start_date && b.sooperdeal_price !== undefined;

          if (isSooperDealA && !isSooperDealB) return -1;
          if (!isSooperDealA && isSooperDealB) return 1;

          if (isSooperDealA && isSooperDealB) {
            return new Date(a.sooperdeal_start_date) - new Date(b.sooperdeal_start_date);
          }

          return 0;
        });

        // Update state with filtered and sorted listings
        setProducts(filteredListings);
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching products:", error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [db, environment, collectionPath]);


  return (
    <PageLayout analyticsView="homepage" analyticsTitle="Home Page" showNewsletterModal>
      <Header search={false} theme="light" />
      <Hero />
      <div css={{ maxWidth: "1140px", margin: "0 auto" }}>
        <FindYourVibe />
        <PageLineBreak />
        <div style={{ padding: "0px 10px" }}>
          <CategoryBrowse />
        </div>
        <PageLineBreak />
        {isMobile && <FeaturedCarousel_MobileV2 featuredCollection={"homepage_1"} />}
        {!isMobile && <FeaturedCarousel_DesktopV2 featuredCollection={"homepage_1"} />}
        <PageLineBreak />
        {loading ? <div className="loading">Loading...</div> :
          <HorizontalListing_Homepage
            title="Popular Products"
            categoryLink="product-category/popular-products"
            products={products.filter((product) => product.popular_product === true)}
            limit={10}
            showBottomLink={true}
            arrow={true}
            buttonText={"Shop Popular"}
          />}
        <PageLineBreak />
        {isMobile && <FeaturedCarousel_MobileV2 featuredCollection={"homepage_2"} />}
        {!isMobile && <FeaturedCarousel_DesktopV2 featuredCollection={"homepage_2"} />}
        <PageLineBreak />
        {loading ? <div className="loading">Loading...</div> :
          <HorizontalListing_Homepage
            title="Staff Picks For You"
            categoryLink="product-category/staff-picks"
            products={products.filter((product) => product.staff_pick === true)}
            limit={10}
            showBottomLink={true}
            arrow={true}
            buttonText={"Shop Staff Picks"}
          />
        }
        <PageLineBreak />
        <Testimonial />
        <Knowledge />
        <FAQ />
      </div>
    </PageLayout>
  );
};

export default Homepage;
